import BrickMenu from "./BrickMenu";
import "./Menu.less";

const Menu = () => {
  return (
    <div className="popup-menu">
      <div className="menu-card" style={{ padding: 0 }}>
        <BrickMenu />
      </div>
    </div>
  );
};

export default Menu;
